import { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';

export default function AppVersion() {
  const [version, setVersion] = useState<string>('');

  useEffect(() => {
    let cancelled = false;
    fetch('/status', { headers: { Accept: 'application/json' } })
      .then((res) => (res.ok ? res.json() : Promise.reject(res.status)))
      .then((data) => {
        if (!cancelled && data?.version) setVersion(String(data.version));
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  if (!version) return null;

  return (
    <Box sx={{ px: 2.5, py: 2, textAlign: 'center' }}>
      <Typography variant="caption" sx={{ color: 'text.disabled' }}>
        v{version}
      </Typography>
    </Box>
  );
}
